import { Typography, Tooltip } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo, faArrowTrendUp, faArrowTrendDown } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { QrCodeIcon } from "../../assets/qr-code-icon";
import { ArrowPointerIcon } from "../../assets/arrow-pointer-icon";
import styles from "./dashboard.module.scss";

const { Text } = Typography;

interface LeadsMetricCardProps {
  icon: React.ReactNode;
  label: string;
  value: number;
  previousValue: number;
  showTrend: boolean;
  tooltip: string;
  onCaretClick: () => void;
}

const LeadsMetricCard: React.FC<LeadsMetricCardProps> = ({ icon, label, value, previousValue, showTrend, tooltip, onCaretClick }) => {
  const percentageChange = previousValue !== 0 ? ((value - previousValue) / previousValue) * 100 : 0;
  const isIncrease = percentageChange >= 0;

  return (
    <div className={styles.leadsMetricCard} onClick={onCaretClick}>
      <div className={styles.leadsMetricHeader}>
        <span className={styles.leadsMetricIconWrap}>{icon}</span>
        <Text className={styles.leadsMetricLabel}>{label}</Text>
        <Tooltip title={tooltip}>
          <FontAwesomeIcon icon={faCircleInfo} className={styles.cardIcon} />
        </Tooltip>
      </div>
      <div className={styles.leadsMetricBody}>
        <div className={styles.leadsMetricValueGroup}>
          <Text className={styles.cardVal}>{value.toLocaleString()}</Text>
          {showTrend && previousValue > 0 && (
            <Text className={styles.leadsTrend} style={{ color: isIncrease ? "#16D761" : "#f3083b" }}>
              <FontAwesomeIcon icon={isIncrease ? faArrowTrendUp : faArrowTrendDown} style={{ marginRight: 3 }} />
              {Math.abs(percentageChange).toFixed(0)}%
              <Tooltip title={`Previous period: ${previousValue.toLocaleString()}`}>
                <FontAwesomeIcon icon={faCircleInfo} className={styles.cardIcon} />
              </Tooltip>
            </Text>
          )}
        </div>
      </div>
    </div>
  );
};

const LeadsSummary: React.FC<any> = ({ dashboardData, filters }) => {
  const navigate = useNavigate();
  const showTrend = !!filters?.[1];
  const qrScanned = dashboardData?.leadsSummary?.qrCodesScanned?.value ?? 0;
  const qrPrevious = dashboardData?.leadsSummary?.qrCodesScanned?.previousPeriod ?? 0;
  const idClicks = dashboardData?.leadsSummary?.informedDeliveryClicks?.value ?? 0;
  const idPrevious = dashboardData?.leadsSummary?.informedDeliveryClicks?.previousPeriod ?? 0;

  return (
    <div className={styles.leadsContainer}>
      <Text strong className={styles.leadsTitle}>Leads</Text>
      <div className={styles.leadsCards}>
        <LeadsMetricCard
          icon={<QrCodeIcon />}
          label="QR CODES SCANNED"
          value={qrScanned}
          previousValue={qrPrevious}
          showTrend={showTrend}
          tooltip="Number of QR codes scanned in the selected period"
          // TODO: Navigate to Leads Page once it exists
          onCaretClick={() => navigate("/auth")}
        />
        <LeadsMetricCard
          icon={<ArrowPointerIcon />}
          label="INFORMED DELIVERY CLICKS"
          value={idClicks}
          previousValue={idPrevious}
          showTrend={showTrend}
          tooltip="Number of Informed Delivery clicks in the selected period"
          // TODO: Navigate to Leads Page once it exists
          onCaretClick={() => navigate("/auth")}
        />
      </div>
    </div>
  );
};

export default LeadsSummary;
